"use client";

import { ArrowLeftCircleLine } from "@/icons";
import { FC, useContext } from "react";
import cn from "classnames";
import { getDataAutomationId } from "@/helpers";
import { getDataLinkAttributes } from "@/helpers";
import { ComparisonChartContext } from "./ComparisonChartTable";
import { BuilderBlockProps } from "@/types";

export type ComparisonChartControlsProps = {
  leftArrowAriaLabel: string;
  rightArrowAriaLabel: string;
  leftArrowDld: string;
  leftArrowDlt: string;
  rightArrowDld: string;
  rightArrowDlt: string;
} & BuilderBlockProps;

export const ComparisonChartControls: FC<ComparisonChartControlsProps> = ({
  leftArrowAriaLabel,
  rightArrowAriaLabel,
  leftArrowDld,
  leftArrowDlt,
  rightArrowDld,
  rightArrowDlt,
  attributes,
}) => {
  const { scrollLeft, scrollRight, canScrollLeft, canScrollRight } = useContext(
    ComparisonChartContext,
  );

  return (
    (canScrollLeft || canScrollRight) && (
      <div
        {...attributes}
        className={cn("flex flex-row gap-x-8 md:hidden", attributes?.className)}
      >
        <button
          disabled={!canScrollLeft}
          className="text-arrow hover:text-arrow-hover active:text-arrow-pressed disabled:text-arrow-disabled disabled:cursor-not-allowed"
          aria-label={leftArrowAriaLabel}
          onClick={scrollLeft}
          {...getDataLinkAttributes({ dld: leftArrowDld, dlt: leftArrowDlt })}
          {...getDataAutomationId("left-arrow")}
        >
          <ArrowLeftCircleLine height={32} width={32} fill="currentColor" />
        </button>
        <button
          disabled={!canScrollRight}
          className="text-arrow hover:text-arrow-hover active:text-arrow-pressed disabled:text-arrow-disabled disabled:cursor-not-allowed"
          aria-label={rightArrowAriaLabel}
          onClick={scrollRight}
          {...getDataLinkAttributes({ dld: rightArrowDld, dlt: rightArrowDlt })}
          {...getDataAutomationId("right-arrow")}
        >
          <ArrowLeftCircleLine
            height={32}
            width={32}
            fill="currentColor"
            className="rotate-180"
          />
        </button>
      </div>
    )
  );
};
